import { BaseService } from './BaseService';
import {
  UserAuthResult,
  UserQueryResult,
  CreateUpdateUserViewModel,
  UserViewModel,
  UserActionLogResult,
  AuthVeterinaryResult
} from '../models/user';

export class UserService extends BaseService {
  authUser = async (farmNumber: string, email: string, password: string): Promise<UserAuthResult> => {
    const command = JSON.stringify({ farmNumber, email, password });

    const result = await this.Fetch('/auth/webuser', 'POST', command, false);

    return this.FromResult<UserAuthResult>(result);
  };

  authVeterinary = async (number: string, email: string, password: string): Promise<AuthVeterinaryResult> => {
    const command = JSON.stringify({ number, email, password });

    const result = await this.Fetch('/auth/vet', 'POST', command, false);

    return this.FromResult<AuthVeterinaryResult>(result);
  };

  getFarmUsers = async (page: number, size: number): Promise<UserQueryResult> => {
    const query = this.BuildQueryString({ page, size });

    const result = await this.Fetch(`/users/search?${query}`, 'GET');

    return this.FromResult<UserQueryResult>(result);
  };

  getUserView = async (id: string): Promise<UserViewModel> => {
    const query = this.BuildQueryString({ id });

    const result = await this.Fetch(`/users?${query}`, 'GET');

    return this.FromResult<UserViewModel>(result);
  };

  searchUserActionLog = async (
    userId: string,
    actionType: number,
    number: string,
    macAddress: string,
    dateFrom: Date | null,
    dateTo: Date | null,
    page: number,
    size: number
  ): Promise<UserActionLogResult> => {
    const command = JSON.stringify({ userId, actionType, number, macAddress, dateFrom, dateTo, page, size });

    const result = await this.Fetch(`/users/actions/search`, 'POST', command);

    return this.FromResult<UserActionLogResult>(result);
  };

  createUser = async (model: CreateUpdateUserViewModel): Promise<string> => {
    const result = await this.Fetch('/users', 'POST', JSON.stringify(model));

    return this.FromResult<string>(result);
  };

  updateUser = async (model: CreateUpdateUserViewModel): Promise<string> => {
    const result = await this.Fetch('/users', 'PUT', JSON.stringify(model));

    return this.FromResult<string>(result);
  };

  getConfig = async (): Promise<object> => {
    const result = await this.Fetch('/config', 'GET', null, false);

    return this.FromResult<object>(result);
  };
}

export default UserService;
